








































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import PositionDto from '@/models/Positions/PositionDto'
import PositionEdit from '@/components/Positions/PositionEdit.vue'
import PositionCreate from '@/components/Positions/PositionCreate.vue'
import GiganautVue from '@/components/Shared/GiganautVue';

@Component({
  name: 'Positions',
  components: { PositionCreate, PositionEdit }
})
export default class extends GiganautVue {

    async beforeMount() {
        AgencySettingsModule.updateCurrentPosition(null);
    }

    async updateCurrentPosition(position: PositionDto) {
        await AgencySettingsModule.updateCurrentPosition(position);
    }

    get currentPosition() {
        return AgencySettingsModule.currentPosition;
    }

    get loadingPositions() {
        return AgencySettingsModule.loadingPositions;
    }

    get positions() {
        return AgencySettingsModule.positions;
    }
}
